import React from "react"
import { MapPin } from "lucide-react"
import SearchSuggestionsRow from "./SearchSuggestionsRow"

const SearchSuggestionsSection = ({ section, selectAirport, isOvercrowded }) => {
  return (
    <div className="mb-5">
      <div className="flex items-center gap-2 mb-2">
        <MapPin className="w-4 h-4 text-dark-red" />
        <span className="text-sm font-medium text-dark-gray uppercase">{section.country}</span>
      </div>

      <div className="space-y-1">
        {section.terminals.map((airport, idx) => (
          <SearchSuggestionsRow
            key={idx}
            airport={airport}
            selectAirport={selectAirport}
            isOvercrowded={isOvercrowded}
          />
        ))}
      </div>
    </div>
  )
}

export default SearchSuggestionsSection
